<template>
  <div class="d-sm-none">
    <div
      v-if="objectData.ratingSnippet"
      class="excerpt"
    >
      <i class="icon"><icon-user class="svg-icon svg-fill" /></i>
      "{{ objectData.ratingSnippet }}"
    </div>
  </div>
</template>

<script>

export default {
  name: 'SearchObjectRatingSnippet',
  props: {
    objectData: {
      required: true,
      type: Object,
    },
  },
};
</script>
